import { jsx as _jsx } from "react/jsx-runtime";
import { TemplateForm, useVisiblePages } from "@ploy-ui/template-form";
import { RoutePageProvider } from "../../components/RoutePageProvider";
const noPages = [];
export const RenderTemplateWithRouteState = (props) => {
    const pages = useVisiblePages(props.template?.pages ?? noPages);
    return (_jsx(RoutePageProvider, { labelsWithEvents: pages.map(p => ({
            label: (p.pageUri?.trim().length ?? 0) > 0 ? p.pageUri : p.pageTitle,
            gtmPageEvent: p.gtmPageEvent
        })), children: _jsx(TemplateForm, { ...props }) }));
};
//# sourceMappingURL=renderTemplate.js.map